// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { warehouseLeadRoute, warehouseLeadRouteAbsolute } from '../roleRoutes/warehouseLead';
// Styles, images, icons
import { icons } from '~/assets';

export const privateWarehouseLeadRoutes: IRouteModel[] = [
  // Dashboard
  {
    index: true,
    path: warehouseLeadRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Global
  {
    path: warehouseLeadRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: warehouseLeadRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: warehouseLeadRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: warehouseLeadRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: warehouseLeadRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.leads}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.leads}${warehouseLeadRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: warehouseLeadRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.clients}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.crm}${warehouseLeadRoute.clients}${warehouseLeadRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: warehouseLeadRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: warehouseLeadRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.jobs}${warehouseLeadRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: warehouseLeadRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: warehouseLeadRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: warehouseLeadRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: warehouseLeadRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.quotes}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: warehouseLeadRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.order}${warehouseLeadRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.order}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: warehouseLeadRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: warehouseLeadRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.invoice}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.quotes}${warehouseLeadRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: warehouseLeadRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: warehouseLeadRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: warehouseLeadRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: warehouseLeadRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: warehouseLeadRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.product}${warehouseLeadRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.product}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.package}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.inventory}${warehouseLeadRoute.package}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.reports}${warehouseLeadRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },

  // Package
  {
    path: warehouseLeadRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: warehouseLeadRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: warehouseLeadRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: warehouseLeadRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: warehouseLeadRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: warehouseLeadRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: warehouseLeadRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: warehouseLeadRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.purchaseOrder}${warehouseLeadRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: warehouseLeadRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: warehouseLeadRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.users}${warehouseLeadRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: warehouseLeadRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.users}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: warehouseLeadRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.venue}${warehouseLeadRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: warehouseLeadRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.venue}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: warehouseLeadRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: warehouseLeadRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${warehouseLeadRoute.base}${warehouseLeadRoute.settings}${warehouseLeadRoute.roleManagement}${warehouseLeadRoute.commonDetail}${warehouseLeadRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: warehouseLeadRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: warehouseLeadRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: warehouseLeadRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: warehouseLeadRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
